<template>
    <li class="nav-item dropdown" :class="{'show': show}" @click="show = !show" v-click-outside="close">
        <a class="nav-link dropdown-toggle"
           href="#"
           role="button"
           data-toggle="dropdown"
           aria-haspopup="true"
           :aria-expanded="show">
            {{ locales[locale] }}
        </a>
        <div class="dropdown-menu" :class="{'show': show}">
            <a v-for="(value, key) in locales"
               :key="key"
               class="dropdown-item"
               href="#"
               @click.prevent="setLocale(key)">
                {{ value }}
            </a>
        </div>
    </li>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'AppLocaleDropdown',
    data() {
        return {
            selectedLocale: '',
            show: false
        };
    },
    computed: {
        ...mapGetters(['locale', 'locales'])
    },
    methods: {
        setLocale(locale) {
            if (this.$i18n.locale !== locale) {
                this.$store.dispatch('SET_LOCALE', locale).then(() => {
                    this.selectedLocale = locale;
                }).catch(() => {
                    if (locale !== 'en') {
                        this.setLocale('en');
                    }
                });
            }
            this.$emit('close');
        },
        close() {
            this.show = false;
        }
    }
};
</script>
